import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { Domain } from '~src/settings/bridge-settings/sections/types/Domain';

export type DeleteBridgePoolDialogProps = Readonly<{
  poolName: string;
  hasAgents: boolean;
  hasDomains: boolean;
  domains: Domain[];
}>

const dialogClass = style({ marginBottom: 30, whiteSpace: 'break-spaces' });
const listClass = style({ maxHeight: 100, overflowY: 'auto', overflowX: 'clip' });
const listItemClass = style({ listStyleType: 'none', paddingInlineStart: TabStyles.Spacing.LargeSpace });

export function DeleteBridgePoolDialogBody(props: DeleteBridgePoolDialogProps) {
  const routingRulesEnabled = FeatureFlags.edgeRoutingFiltersWithProjectsEnabled;
  return (
    <div className={dialogClass}>
      <div
        data-tb-test-id='delete-pool-warning'
        data-warning-variant={routingRulesEnabled ? 'routing-rules' : 'standard'}
        data-warning-has-agents={props.hasAgents ? 'true' : 'false'}
      >
        {getDeletePoolMessage(props)}
      </div>
      <div className={listClass}>
        {!routingRulesEnabled && props.hasDomains &&
          <ul id='domainList' className={listItemClass}>
            {props.domains.map(domain => {
              return <li key={domain.domainName}>{domain.domainName}</li>;
            })}
          </ul>
        }
      </div>
    </div>
  );
}

function getDeletePoolMessage(props: DeleteBridgePoolDialogProps) {
  if (FeatureFlags.edgeRoutingFiltersWithProjectsEnabled) {
    return getDeletePoolMessageWithRoutingRuleEnabled(props);
  }
  let message = Messages.bridgeSiteSettingsDeletePoolWarning({ POOL_NAME: L10n.elideIfLong(props.poolName) });
  if (props.hasAgents && props.hasDomains) {
    message += ' ' + Messages.bridgeSiteSettingsDeletePoolWithAgentsAndDomains();
  }
  else if (props.hasAgents) {
    message += ' ' + Messages.bridgeSiteSettingsDeletePoolWithAgents();
  }
  else if (props.hasDomains) {
    message += ' ' + Messages.bridgeSiteSettingsDeletePoolWithDomains();
  }
  return message;
}

function getDeletePoolMessageWithRoutingRuleEnabled(props: DeleteBridgePoolDialogProps) {
  let message = Messages.bridgeSiteSettingsDeletePoolWarningWithRoutingRules({ POOL_NAME: L10n.elideIfLong(props.poolName) });
  if (props.hasAgents) {
    message += ' ' + Messages.bridgeSiteSettingsDeletePoolWithAgents();
  }
  return message;
}
